import { render, staticRenderFns } from "./userTask.vue?vue&type=template&id=0aa48449&scoped=true&"
import script from "./userTask.vue?vue&type=script&lang=js&"
export * from "./userTask.vue?vue&type=script&lang=js&"
import style0 from "./userTask.vue?vue&type=style&index=0&id=0aa48449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa48449",
  null
  
)

export default component.exports